export const linkForCheck = {
  notifications: '/notifications'
}
